@if (sessionToShow) {
    @if (!viewportService.isMobile()) {
        <section
            role="region"
            aria-label="Upcoming session"
            class="w-full h-auto bg-p-content-background bp908:rounded-2xl p-4 pt-2 bp908:shadow-p-form-field-shadow font-inter border border-p-content-border-color">
            <div class="w-full flex flex-row justify-start items-center">
                <div class="text-muted-color font-medium text-14 leading-[normal]">
                    @if (!isSessionOngoing) {
                        Upcoming
                    } @else {
                        Ongoing
                    }
                </div>
            </div>

            @if (!sessionToShow) {
                <div class="flex flex-col justify-center items-center w-full">
                    <div
                        class="text-muted-color font-inter font-medium text-[12px] p-[8px] leading-normal w-full text-center rounded-lg bg-blurple-4">
                        No upcoming sessions
                    </div>
                </div>
            } @else {
                <div class="w-full flex flex-col justify-start items-center">
                    <div class="flex flex-col justify-center items-center w-full">
                        @if (showTimer) {
                            <app-fm-timer
                                class="w-full text-[#F97316] font-meidum text-left text-12 leading-[normal] mb-2 mt-4"
                                [sessionTime]="getSessionTime(sessionToShow)"
                                [sessionType]="getSessionType(sessionToShow)"
                                [sessionDuration]="getSessionDuration(sessionToShow)"
                                [isInSessionTimer]="false"
                                [isValidSession]="true"
                                [isTestSession]="false" />
                        } @else {
                            <div
                                class="w-full font-meidum text-left text-12 leading-[normal] text-muted-color mb-2 mt-4">
                                {{
                                    this.getSessionTime(sessionToShow)
                                        | epochToTime
                                            : {
                                                  format: 'dddd, MMMM D',
                                                  timezone: this.timeZone,
                                                  useTodayTomorrow: true,
                                              }
                                }}
                            </div>
                        }

                        @if (getAmbassadorMatch(sessionToShow)) {
                            <div
                                class="animation-elastic-z-entry relative w-full pr-[4px] mb-2 mt-2 cursor-pointer"
                                (click)="onClickAmbassadorMatchInfo()">
                                <div
                                    class="effect-shine w-full flex flex-row items-center gap-2 p-[8px] rounded-lg bg-yellow-100 border border-[#FFE9A9] text-primary text-sm">
                                    @if (isNewUserForAmbassadorProgram) {
                                        <span class="font-medium"
                                            >Your partner is a Guide!
                                            <span class="underline font-normal"
                                                >Learn&nbsp;more</span
                                            ></span
                                        >
                                    } @else {
                                        <span class="font-medium">Your partner is new!</span
                                        ><i class="pi pi-info-circle"></i>
                                    }
                                </div>
                                <div class="absolute top-[-8px] left-[-8px] text-[20px]">👋</div>
                            </div>
                        }

                        @if (isGroupMeeting(sessionToShow)) {
                            <fm-group-meeting-tile
                                class="w-full"
                                height="114"
                                [groupMeetingInfo]="sessionToShow"
                                [timezone]="timeZone"
                                [doNotAnimateIn]="true"
                                source="upcomingSessions"
                                [timeFormat]="
                                    profileInfo.settings.timeFormat
                                "></fm-group-meeting-tile>
                        } @else {
                            <fm-booked-session-tile
                                class="w-full"
                                height="92"
                                [sessionInfo]="sessionToShow"
                                [partnerInfo]="getSessionPartnerInfo(sessionToShow)"
                                [timezone]="timeZone"
                                [doNotAnimateIn]="true"
                                source="upcomingSessions"
                                [timeFormat]="profileInfo.settings.timeFormat"
                                [alwaysShowJoinSession]="true" />
                        }
                    </div>
                </div>
            }
        </section>
    }
    <!-- Mobile Version -->
    @else {
        @if (mobileShowUpcomingSession) {
            <section
                aria-label="Upcoming session"
                class="flex flex-col gap-0 justify-center items-center w-full py-[2px] bg-orange-100 border-t border-orange-200">
                <p-button
                    [buttonProps]="{ autofocus: false }"
                    (click)="onClickSessionBanner()"
                    variant="text"
                    severity="warn"
                    class="w-full"
                    styleClass="w-full !h-[unset]">
                    <div class="flex justify-center items-center w-full underline py-[2px]">
                        <div class="font-medium">
                            @if (isGroupMeeting(sessionToShow)) {
                                Group session at
                            } @else {
                                Session at
                            }
                            {{
                                this.getSessionTime(sessionToShow)
                                    | epochToTime
                                        : {
                                              format:
                                                  profileInfo.settings.timeFormat == '12hr'
                                                      ? 'h:mma'
                                                      : 'H:mm',
                                              timezone: this.timeZone,
                                              useTodayTomorrow: true,
                                          }
                            }}
                        </div>
                        <span>&nbsp;·&nbsp;</span>

                        <app-fm-timer
                            class="text-warn-color dark:text-orange-400 font-medium"
                            [sessionTime]="getSessionTime(sessionToShow)"
                            [sessionType]="getSessionType(sessionToShow)"
                            [sessionDuration]="getSessionDuration(sessionToShow)"
                            [isInSessionTimer]="false"
                            [isValidSession]="true"
                            [isTestSession]="false" />
                    </div>
                </p-button>
            </section>
            @if (getAmbassadorMatch(sessionToShow)) {
                <section
                    aria-label="Upcoming session"
                    class="flex flex-col gap-0 justify-center items-center w-full py-[2px] bg-yellow-100 border-t border-yellow-300">
                    <p-button
                        [buttonProps]="{ autofocus: false }"
                        (click)="onClickAmbassadorMatchInfo()"
                        variant="text"
                        severity="warn"
                        class="w-full"
                        styleClass="w-full !h-[unset] py-[2px]">
                        <div class="flex justify-center items-center w-full underline text-primary">
                            @if (isNewUserForAmbassadorProgram) {
                                👋 Your partner is a Focusmate Guide!
                            } @else {
                                👋 Your partner is new to Focusmate!
                            }
                        </div>
                    </p-button>
                </section>
            }
        }
    }
}
